import React from 'react';

// Section 1 — About Frontier & Mission (asymmetric center-right editorial opening).
export const AboutSection = () => (
  <section className="pt-20 pb-20 sm:pt-28 sm:pb-28 px-6 sm:px-10 lg:px-16 border-b border-stone-200/80 bg-[#FBFBFB]">
    <div id="about" className="scroll-mt-20 w-full max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">

      {/* Left negative space */}
      <div className="hidden lg:block lg:col-span-4" />

      {/* Right editorial column */}
      <div className="lg:col-span-8 max-w-3xl">
        <div className="text-xs uppercase tracking-wider mb-6 flex items-center gap-2 font-sans font-medium text-stone-500">
          <span className="font-bold text-stone-950 tracking-[0.16em]">FRONTIER</span>
          <span className="text-stone-300">·</span>
          <span className="text-stone-600 font-semibold tracking-wider text-[11px] sm:text-xs">STRATEGIC DEAL-MAKING FOR THE AGENTIC ERA</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] xl:text-[3.5rem] font-bold tracking-tight text-stone-950 leading-[1.1] mb-8">
          Frontier is the agentic operating system for strategy and high-stakes deals.
        </h1>

        <div className="space-y-5 text-base sm:text-lg text-stone-700 leading-relaxed font-sans font-normal">
          <p className="text-lg sm:text-xl text-stone-900 font-medium leading-snug">
            We support dealmakers in sourcing, diligence, value creation, and exit across critical transactions.
          </p>
          <p>
            For decades, dealcraft relied on brute-force human labor: weeks of manual reviews, static slide decks, and financial models that decayed the moment they were delivered.
          </p>
          <p>
            We are building Frontier to unlock unparalleled conviction for investment committees—turning weeks of fragmented analysis into days of decisive clarity. It is a new standard of collaboration between strategic intuition and frontier intelligence.
          </p>
          <p>
            <strong className="font-bold text-stone-950">Our mission</strong> is to empower exceptional dealmakers. We make this a reality by building sovereign intelligence engines that shoulder transaction complexity, freeing leaders to focus on what matters most: sharp judgment, strategic courage, and decisive action.
          </p>
        </div>
      </div>

    </div>
  </section>
);
